module.exports = __webpack_public_path__ + "static/media/IconePerfil.a453d508.svg";